export const currencyRoute = {
  CURRENCY_LIST: '/currency/list',
  CURRENCY_DETAIL: '/currency/detail/:recordId',
};
